// site header
window.addEventListener('DOMContentLoaded', () => {
  // toggle mobile menu hamburger
  let headerBurger = document.querySelector('.hamburger.header-toggle');
  headerBurger.addEventListener('click', (e) => {
    document.body.classList.toggle('menu-open');
    e.currentTarget.classList.toggle('active')
  });

  // toggle mobile menu
  let menuParent = document.querySelectorAll('.menu-dropdown');
  if (menuParent.length > 0) {
    menuParent.forEach(item => {
      item.addEventListener('click', (e) => {
        let that = e.currentTarget;
        that.closest('.has-child').classList.toggle('active');
      })
    })
  }

  // sticky header
  let stickyHeader = document.querySelector('.header-index.header-sticky');
  if (stickyHeader) {
    let scrollPosition = window.scrollY;
    window.addEventListener('scroll', () => {
      let currScrollPosition = window.scrollY;
      (window.scrollY >= 200) ? stickyHeader.classList.add('is-sticky') : stickyHeader.classList.remove('is-sticky');
      if (scrollPosition <= currScrollPosition ) {
        stickyHeader.classList.add('sticky-header-hidden');
        stickyHeader.classList.remove('sticky-header-visible');
      } else {
        stickyHeader.classList.add('sticky-header-visible');
        stickyHeader.classList.remove('sticky-header-hidden');
      }
      scrollPosition = window.scrollY;
    })
  }

  // init predictive search
  let searchTrigger = document.querySelector('.actions-wrapper .action-search');
  let searchPopEle = document.querySelector('#predictiveSearchModal');
  if (searchTrigger) {
    searchTrigger.addEventListener('click', (e) => {
      e.preventDefault()
      searchPopEle.classList.add('active');
      setTimeout(() => {
        document.querySelector('#predictive-Search').focus();
      }, 250);
      document.body.classList.toggle('search-warpper-open');
    })  
  }
  // close predictive search modal
  let searchCloseTrigger = document.querySelector('#closeSearchModal');
  searchCloseTrigger.addEventListener('click', () => {
    searchPopEle.classList.remove('active');
    searchTrigger.focus();
    document.querySelector('#predictive-Search').value = '';
    document.querySelector('#predictive-Search').dispatchEvent(new Event('input'))
    document.body.classList.toggle('search-warpper-open');
  })

})